'use client';

import { EntryBaseFragment } from '@/__generated__/graphql';
import useCommonLinks from '@/lib/getters/useCommonLinks';
import { parseCommonLink } from '@/lib/parsers/common/parseCommonLinks';
import { isTypedFragment } from '@liquorice/gql-utils';
import CtaButton from '../CtaButton';
import Box, { BoxProps } from '../ui/Box';
import { BtnStyleProps } from '../ui/Btn';
import Txt, { TxtProps } from '../ui/Txt';

export type Breadcrumbs = BoxProps<
  'div',
  {
    CtaButtonProps?: BtnStyleProps;
    CtaButtonClass?: string;
    TxtProps?: TxtProps;
    data?: EntryBaseFragment | null;
    articleType?: string | null;
  }
>;

export default function Breadcrumbs({
  CtaButtonProps,
  CtaButtonClass,
  TxtProps,
  data,
  articleType,
  ...props
}: Breadcrumbs) {
  const { articleIndex, eventIndex, home, mediaIndex } = useCommonLinks();

  const maybeParent = data?.parent;
  const parent = maybeParent ? parseCommonLink(maybeParent) : home;
  let ancestors = parent ? [parent] : [];

  switch (true) {
    case isTypedFragment(data, 'article_Entry') && articleType === 'news':
      if (articleIndex) ancestors = [articleIndex];
      break;
    case isTypedFragment(data, 'article_Entry') && articleType === 'mediaRelease':
      if (mediaIndex) ancestors = [mediaIndex];
      break;
    case isTypedFragment(data, 'event_Entry'):
      if (eventIndex) ancestors = [eventIndex];
      break;
  }

  return (
    <Box {...props}>
      {ancestors?.map((v, i) => (
        <CtaButton
          key={i}
          href={v.uri ?? ''}
          endIcon={undefined}
          underline="none"
          StartIconProps={{ name: 'chevronLeft' }}
          className={CtaButtonClass}
          {...CtaButtonProps}>
          <Txt {...TxtProps}>{v.title}</Txt>
        </CtaButton>
      ))}
    </Box>
  );
}
